export default {
    login: {
        title: 'Circular Knitting Machine management platform',
        menuTitle: 'Circular Knitting Machine management platform',
        logIn: 'Login',
        username: 'username',
        userHint: 'Please enter your username!',
        userInput: 'Please enter!',
        password: 'Password',
        passwordHint: 'Please enter your password!',
        passwordHint2: 'Letter + number + special symbol length is not less than 8 digits!',
        passwordHint3: 'Please enter your password again!',
        passwordHint4: 'Letter + number + special symbol length is not less than 8 digits!',
        passwordHint5: "Two passwords don't match",
        loginHint: 'No account yet?Register now, ',
        loginSuccess: 'Login successful!',
        registerTitle: 'Register',
        passwordYes: 'Confirm Password',
        registerHint: 'log in using existing account',
        registerSuccess: 'Register successfully!',
        userInfo: 'Personal Settings',
        logOut: 'Log Out',
        cleanData: 'Clean Data',
    },
    router: {
        home: 'Home Page',
        defectRecord: 'Defect Record',
        machine: 'Machine Management',
        user: 'Personal Center',
        userSetting: 'Personal Settings',
        export: 'Export Management',
        cleanData: 'Data Cleaning',
    },
    home: {
        pleaseChoose: 'Please Select',
        equipment: 'Equipment',
        refresh: 'Refresh',
        today: 'Today',
        week: 'This Week',
        moth: 'This Month',
        defectAlarm: 'Defect Alarm',
        defectCurve: 'Defect Curve',
        defectType: 'Defect Type',
        defectNumber: 'Number Of Defects',
        defectCountUnit: '',
        haltCount: 'Number Of Stops',
        last7day: 'Last 7 Days Data',
        eqOverview: 'Overview of Equipment Data',
        eqDowntime: 'Equipment Downtime',
        updateData: 'Update Data',
        defectPercentage: 'Defect Proportion',
        flaw: 'Defect',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        next: 'Second',
        deviceInfo: 'Device Information',
        rpm: 'RPM',
        defectShutdown: 'Defect Shutdown',
        mean: 'Average',
        generalShutdown: "General Shutdown",
        totalDefects: 'Total Defects',
        nonstopDefect: 'Nonstop Defect',
        shutdownDefect: 'Shutdown Defect',
        downtimeDuration: 'Downtime',
        runningTime: 'Running Time',
        hour: "Hour",
    },
    defectRecord: {
        project: 'Owned Project',
        snCode: 'SN code',
        deviceName: 'Device Name',
        data: 'Date',
        defectCause: 'Defect Causes',
        inquire: 'Inquiry',
        reset: 'Reset',
        derive: 'Export',
        deviceSnCode: 'Device SN code',
        cameraNumber: 'Camera Number',
        proNumber: 'Production Number',
        operatorId: 'Worker Number',
        writeTime: 'Record Time',
        row: 'Operation',
        success: 'Request Successful!',
        total: 'Total',
        strip: 'Strip',
        viewsImg: 'View Picture',
        noImg: 'No Picture',
        closeImg: 'Closed',
        views: 'Views',
        pageTheWarning: "That's the first one!",
        pageNextWarning: "It's the last one!",
        importExcel: 'Export to Excel',
        stopStatus: 'Shutdown Status',
        noStop: 'Not stopped',
        yesStop: 'Stopped',
    },
    machine: {
        address: 'Address',
        machineNo: 'Machine Number',
        revolution: 'Rotational Speed',
        signalStrength: 'Signal Strength',
        noMachineInfo: 'No Machine Info'
    },
    account: {
        basicSetup: 'Basic Settings',
        changePassword: 'Change Password',
        nickName: 'NickName',
        gender: 'Sex',
        mal: 'Male',
        female: 'Female',
        mobile: 'Mobile Number',
        mailBox: 'Mailbox',
        address: 'Address',
        updateBasic: 'Update basic information',
        avatar: 'Avatar',
        changeAvatar: 'Change Avatar',
        success: 'Modify successfully!',
        warning: 'Image size limit 1MB!',
        rawPassword: 'Original Password',
        newPassword: 'New Password',
        affirmPassword: 'Confirm Password',
        confirmChange: 'Confirm Modification',
        hint: 'Hint',
        status: 'Status',
        deletedText: 'Delete Succeeded!',
        inExport: 'Exporting',
        offStocks: 'Completed',
        defeated: 'Defeated',
        sum: 'Total',
        startTime: 'Start Time',
        endTime: 'End Time',
        download: 'Download',
        delete: 'Delete',
        exporting: 'Exporting',
    }
}